import Blue from '~/core'
import { createConfig, updateCurrentValues } from './calculator/_config'
import { futureValueAnnualTracking,calculateSavings, debounce, setCurrentDate } from './calculator/_utilities'
import { initializeChart, updateChart, updateChartLabels } from './calculator/_chart'
import { updateRatesTable } from './calculator/_table'
import { registerCursorTracker, formatNumeral, unformatNumeral, DefaultNumeralDelimiter } from 'cleave-zen'

new Blue({
  name: 'Calculator',
  selector: '.calculator--gic',
  setup(calculator) {
    const dataRatesEl = calculator.dataset.ratesEl
    const dataChartId = calculator.dataset.chartId

    let localRateTable = []

    const initialInput = calculator.querySelector('#initial_investment')
    const investmentLength = calculator.querySelector('#investment_length')
    const alternateInput = calculator.querySelector('#alternate_rate')

    const ratesEl = calculator.querySelectorAll(`.${dataRatesEl}`)
    const chartCanvas = calculator.querySelector(`#${dataChartId}`)
    const tableEl = calculator.querySelector('.cd__table')

    const formatPercentage = (value) => (Math.round(value * 100) / 100).toFixed(2)

    const config = createConfig('gic')
    config.elements = {
      chart: chartCanvas,
      table: tableEl,
    }

    config.currentValues = {
      initial_investment: 25000,
      investment_length: 12,
      alternate_rate: 0.0,
    }

    const getRate = (initialInvestment, rates) => {
      let finalRate

      for (let i = 0; i < rates.length; i++) {
        const [threshold, rate] = rates[i].map(Number)
        if (initialInvestment < threshold) {
          finalRate = formatPercentage(i === 0 ? rates[0][1] : rates[i - 1][1])
          return finalRate
        }
      }

      finalRate = formatPercentage(rates[rates.length - 1][1])
      return finalRate
    }

    // Function to prepare updates based on changes in the investment scenario
    const prepareUpdate = () => {
      // This is a defualt if the value coming from the input is malformed
      let alternateRateValue = 1.83

      const initialInvestment = config.currentValues.initial_investment
      const investmentLength = config.currentValues.investment_length
      const alternateRate = config.currentValues.alternate_rate

      const currentRateTable = window.rateTable[investmentLength]
      const rateTiers = [0, 100000, 250000]

      localRateTable = currentRateTable.map((value, index) => [rateTiers[index], value])

      const percentageFormat = /^\d{1,3}(\.\d{1,2})?$/
      if (percentageFormat.test(alternateRate)) {
        alternateRateValue = alternateRate
      }
      const rate = getRate(unformatNumeral(initialInvestment + ''), localRateTable)

      // Set up tiers visual
      ratesEl.forEach((el, idx) => {
        el.classList.remove('current', 'hidden')
        if (localRateTable[idx]) {
          const currentRate = localRateTable[idx][1].toFixed(2)
          el.innerText = `${currentRate}%`
          if (rate === currentRate) {
            el.classList.add('current')
          }
        } else {
          el.classList.add('hidden')
        }
      })
      // Sent to updateChart(config)
      const rates = {
        scu: parseFloat(rate),
        banks: parseFloat(alternateRateValue),
      }

      // calculateSavings(config, 'scu', rates.scu, 0, investmentLength / 12)
      // calculateSavings(config, 'banks', rates.banks, 0, investmentLength / 12)
      futureValueAnnualTracking(config, 'scu',  rates.scu, investmentLength)
      futureValueAnnualTracking(config, 'banks', rates.banks, investmentLength)

      updateChartLabels(config, config.currentValues.investment_length / 12)
      updateChart(config, config.currentValues, config.currentSavings, rates)

      updateRatesTable(config, 0)
    }

    const initInputs = () => {
      document.querySelectorAll('select[data-styled]').forEach(function (select) {
        // const numberOfOptions = select.options.length

        // Add the `select-hidden` class and wrap the element
        select.classList.add('select-hidden')
        const wrapper = document.createElement('div')
        wrapper.className = 'select'
        select.parentNode.insertBefore(wrapper, select)
        wrapper.appendChild(select)

        // Create the styled select element
        const styledSelect = document.createElement('div')
        styledSelect.className = 'select-styled'
        styledSelect.textContent = select.options[0].textContent
        wrapper.appendChild(styledSelect)

        // Create the list of options
        const list = document.createElement('ul')
        list.className = 'select-options'
        wrapper.appendChild(list)

        Array.from(select.options).forEach(function (option, index) {
          const listItem = document.createElement('li')
          listItem.textContent = option.textContent
          listItem.setAttribute('rel', option.value)

          if (option.selected) {
            listItem.classList.add('is-selected')
          }

          if (option.dataset.spec !== undefined) {
            listItem.classList.add('is-spec')
          }

          list.appendChild(listItem)
        })

        const listItems = list.querySelectorAll('li')

        // Toggle dropdown on click
        styledSelect.addEventListener('click', function (e) {
          e.stopPropagation()
          document.querySelectorAll('.select-styled.active').forEach(function (activeSelect) {
            if (activeSelect !== styledSelect) {
              activeSelect.classList.remove('active')
              activeSelect.nextElementSibling.style.display = 'none'
            }
          })

          styledSelect.classList.toggle('active')
          list.style.display = styledSelect.classList.contains('active') ? 'block' : 'none'
        })

        // Handle option selection
        listItems.forEach(function (item) {
          item.addEventListener('click', function (e) {
            e.stopPropagation()

            styledSelect.textContent = this.textContent
            styledSelect.classList.remove('active')
            list.style.display = 'none'

            select.closest('div.select').classList.toggle('has-info', this.classList.contains('is-spec'))

            // Update the original select value
            select.value = this.getAttribute('rel')
            updateCurrentValues('gic', 'investment_length', select.value)
            prepareUpdate()
            // Update the selected class
            list.querySelectorAll('.is-selected').forEach(function (selectedItem) {
              selectedItem.classList.remove('is-selected')
            })
            this.classList.add('is-selected')
          })
        })

        // Close dropdown on clicking outside
        document.addEventListener('click', function () {
          styledSelect.classList.remove('active')
          list.style.display = 'none'
        })
      })

      const dollarPrefix = {
        prefix: '$',
      }

      registerCursorTracker({
        input: initialInput,
        delimiter: DefaultNumeralDelimiter,
      })

      initialInput.value = formatNumeral('25000', dollarPrefix)
      alternateInput.value = formatNumeral(formatPercentage(alternateInput.dataset.default)) + '%'

      initialInput.addEventListener('input', (e) => {
        e.target.classList.remove('has-error')
        const bareValue = unformatNumeral(e.target.value)
        if (bareValue < 500) {
          e.target.classList.add('has-error')
        }
        const value = formatNumeral(e.target.value, dollarPrefix)
        initialInput.value = value
      })

      alternateInput.addEventListener('input', (e) => {
        const value = formatNumeral(e.target.value, { delimiter: '.' })
        alternateInput.value = value + '%'
      })

      // Attach a listener to the other inputs
      calculator.querySelector('.calculator__calculate').addEventListener(
        'input',
        debounce(function (event) {
          if (event.target.classList.contains('cc-field__input')) {
            updateCurrentValues('gic', event.target.id, parseFloat(unformatNumeral(event.target.value)))
            prepareUpdate()
          }
        }, 300),
      )
    }

    const updateAllValues = () => {
      const investmentValue = parseInt(investmentLength.value) >= 1 ? investmentLength.value : '1'

      updateCurrentValues('gic', 'initial_investment', parseInt(unformatNumeral(initialInput.value)))
      updateCurrentValues('gic', 'investment_length', parseInt(unformatNumeral(investmentValue)))
      updateCurrentValues('gic', 'alternate_rate', parseInt(unformatNumeral(alternateInput.value)))
    }

    initInputs()
    setCurrentDate()
    initializeChart(config)
    updateAllValues()
    prepareUpdate()
  },
})

new Blue({
  name: 'Squiggly',
  selector: '#squiggles',
  setup(squiggles) {
    const lottie = squiggles.getLottie()
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            lottie.play()
            observer.unobserve(squiggles)
            return
          }
        })
      },
      {
        rootMargin: "0px 0px -20% 0px",
      },
    )

    observer.observe(squiggles)

  },
})
